var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppLogoPlaceholder = function SvgAppLogoPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.54075,0 C22.5525,0 24.058,0 25.67925,0.5125 C27.44925,1.15675 28.84325,2.55075 29.4875,4.32075 C30,5.94175 30,7.44775 30,10.45925 L30,19.54075 C30,22.5525 30,24.058 29.4875,25.67925 C28.84325,27.44925 27.44925,28.84325 25.67925,29.48725 C24.058,30 22.5525,30 19.54075,30 L10.45925,30 C7.4475,30 5.94175,30 4.32075,29.48725 C2.55075,28.84325 1.15675,27.44925 0.5125,25.67925 C0,24.058 0,22.5525 0,19.54075 L0,10.45925 C0,7.44775 0,5.94175 0.5125,4.32075 C1.15675,2.55075 2.55075,1.15675 4.32075,0.5125 C5.94175,0 7.4475,0 10.45925,0 L19.54075,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.200000003 0",
    type: "matrix",
    "in": "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "app-icon"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))));
};
export default SvgAppLogoPlaceholder;